import React from 'react'
import Contact from '../Contact/Contact'
import FrequentlyAsked from '../FrequentlyAsked/FrequentlyAsked'
import Newsletter from '../Newsletter/Newsletter'

const ContactPage = () => {
  
  return (
    <div>
      <Contact />
      <FrequentlyAsked />
      <Newsletter />
    </div>
  )
}

export default ContactPage
